import React from 'react';
import Calendar from './index';
import ErrorBoundary from '../../../components/ErrorBoundary';

const HelpButton = React.lazy(() => import('../../../components/HelpButton'));
const CalendarAppointmentResultsList = React.lazy(() =>
  import('./CalendarAppointmentResultsList')
);
const CalendarAppointmentResultsPage = () => {
  return (
    <Calendar scrolling>
      <ErrorBoundary>
        <React.Suspense fallback={<div />}>
          <>
            <div className="text-right mb-2">
              <HelpButton fileName="appointments-outcomes" />
            </div>
            <CalendarAppointmentResultsList />
          </>
        </React.Suspense>
      </ErrorBoundary>
    </Calendar>
  );
};

export default CalendarAppointmentResultsPage;
